export default "__VITE_ASSET__Zm9ivwUs__"